import { attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  title: attr('string'),
  completedAt: attr('date'),
  totalInvoice: attr('number'),
  totalPayment: attr('number'),
  costCode: attr('string'),
  storyCode: attr('string'),
  buyer: attr(),
  seller: attr(),
  status: attr('string'),
});
